import { render, staticRenderFns } from "./LineSelectDetail.vue?vue&type=template&id=4824f004&scoped=true"
import script from "./LineSelectDetail.vue?vue&type=script&lang=js"
export * from "./LineSelectDetail.vue?vue&type=script&lang=js"
import style0 from "./LineSelectDetail.vue?vue&type=style&index=0&id=4824f004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824f004",
  null
  
)

export default component.exports